(function(angular) {
    'use strict';

    // Can add to this as necessary
    // The Angular version of this is PermissionNames
    var permissions = {
        Schedule: 'schedule',
        FullNoteComposer: 'fnc',
        StrikeoutVisits: 'strikeoutvisits',
    };

    angular.module('aprima-legacy-common').constant('Permissions', permissions);
})(window.angular);
